import { FormModel } from "../../../utils/FormModel";

export class ChangeEvent extends FormModel {
    
    public message: string = "";
    public dateGenerated: string = "";
    public user: string = "";
}
